import React, { useEffect, useState } from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import THead from 'components/ContentBox/Global/ReportTable/THead'
import st from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import { NavLink, useHistory } from 'react-router-dom'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { observer } from 'mobx-react'

const NewStudents = () => {
  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()
  const [groupCatalog, setGroupCatalog] = useState({})
  const dateAfter = new Date()
  const firstDayOfLastMoth = new Date(
    dateAfter.getFullYear(),
    dateAfter.getMonth(),
    1,
  )
  const lastDayOfLastMoth = new Date(
    dateAfter.getFullYear(),
    dateAfter.getMonth() + 1,
    0,
  )

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })
  const [filter, updateFilter] = useLocalStorageFilter()
  const history = useHistory()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const filterCnf = [
    {
      type: 'select-multi',
      label: 'Локация',
      placeholder: 'Локация',
      values: groupCatalog?.locations,
      sort_key: 'name',
      nameState: 'location',
    },
    {
      type: 'date_day_picker',
      defaultDate: {
        after: firstDayOfLastMoth,
        before: lastDayOfLastMoth,
      },
      nameState: ['date_from', 'date_until'],
      label: 'Период',
      isRequired: true,
    },
    {
      type: 'type_selector',
      nameState: 'online',
      label: 'Формат',
      values: [
        { id: 2, name: 'Все группы' },
        { id: 1, name: 'Онлайн' },
        { id: 0, name: 'Офлайн' },
      ],
    },
    {
      type: 'select-multi',
      label: 'Уровень курса',
      placeholder: 'Уровень курса',
      values: groupCatalog?.course_levels,
      sort_key: 'name',
      nameState: 'course_level',
    },
    {
      type: 'select-multi',
      label: 'Уровень группы',
      placeholder: 'Уровень группы',
      values: groupCatalog?.skill_levels,
      sort_key: 'name',
      nameState: 'skill_level',
    },
  ]

  const cols = [
    {
      name: 'Ф.И.О. студента',
    },
    { name: 'Школа', rowSpan: 3 },
    { name: 'Группа', rowSpan: 3 },
  ]

  const parseData = (res) => {
    let clientsList = []
    res.data.result.forEach((item) => {
      let newItem = {
        student: {
          id: item.id,
          user_id: item.user_id,
          full_name: item.full_name,
        },
        group: {
          id: item.group.id,
          name: item.group.name,
        },
        location_name: res.data.locations.find(
          (loc) => loc.id === item.group.location,
        ).name,
      }
      clientsList.push(newItem)
    })
    return clientsList
  }

  const fetchData = (filter) => {
    setIsLoading(true)

    const params = { ...filter }

    if (params.location && params.location.length > 0)
      params.location = `[${params.location.map((item) => item)}]`
    if (params.skill_level && params.skill_level.length > 0)
      params.skill_level = `[${params.skill_level.map((item) => item)}]`
    if (params.course_level && params.course_level.length > 0)
      params.course_level = `[${params.course_level.map((item) => item)}]`

    superAxiosRequest({
      method: 'get',
      link: 'progress_report/new_clients_full',
      params: params,
    })
      .then((res) => {
        setGroupCatalog(res.data)
        setData(parseData(res))
        setIsLoading(false)
      })
      .catch(() => setIsLoading(false))
  }

  useEffect(() => {
    fetchData(filter)
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/new_students') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const headRow = [
        {
          v: 'Ф.И.О. студента',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Школа',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Группа',
          ...ExcelRowsParams.headerRowParam,
        },
      ]
      let footerRow = [
        {
          v: `ИТОГО НОВЫХ СТУДЕНТОВ`,
          ...ExcelRowsParams.footerRowParams.firstCell,
        },
        {
          v: `${data.length}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: ``,
          ...ExcelRowsParams.footerRowParams.cell,
        },
      ]
      let tableData = []

      let merges = []
      let wscols = [{ wch: 40 }, { wch: 30 }, { wch: 50 }]
      let rows = [{ hpx: 30 }]

      data.forEach((studentItem) => {
        tableData.push([
          {
            v: `${studentItem.student.full_name}`,
            ...ExcelRowsParams.tableRowParam.firstCell,
          },
          {
            v: `${studentItem.location_name}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${studentItem.group.name}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
        ])
      })

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData, footerRow])
      ws['!cols'] = wscols
      ws['!merges'] = merges
      ws['!rows'] = rows
      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Новые студенты.xlsx')
    })
  }

  const isFilterEmpty = !filterTextValues.length

  return (
    <div>
      <ContentHeader title='Новые студенты' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>

      {isLoading ? (
        <Loader />
      ) : Array.isArray(data) &&
        data.map((el) => el.dates).flat().length === 0 ? (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      ) : (
        <>
          <div style={{ padding: '10px' }}>
            {data && (
              <ExportExcelButton data={data} downloadExcel={downloadExcel} />
            )}
          </div>
          <div className={st.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={st.sticky}>
              <table className={st.table}>
                <THead cols={cols} />
              </table>
            </div>
            <table className={`${st.table} ${st.tbodyStriped}`}>
              <THead cols={cols} ref={refThead} />
              <tbody className={st.tbody}>
                {Array.isArray(data) && (
                  <>
                    <tr className={st.bdt}>
                      <td className={`${st.tdTotal} ${st.bdrN} ${st.ttu}`}>
                        Итого новых студентов
                      </td>
                      <td
                        className={`${st.tdTotal} ${st.bdlN} ${st.bdrN} ${st.textAlignCenter}`}
                      >
                        {data.length}
                      </td>
                      <td
                        className={`${st.tdTotal} ${st.bdlN} ${st.bdrN} ${st.textAlignCenter}`}
                      />
                    </tr>
                    {data.map((row, rowIdx) => (
                      <tr key={rowIdx} className={st.bdt}>
                        <td
                          className={st.fw600}
                          style={{ background: 'white' }}
                        >
                          <div
                            className={`${st.groupDescription} ${st.medium}`}
                          >
                            <NavLink
                              to={'/account_clients/' + row.student.user_id}
                              target='_blank'
                            >
                              {row.student.full_name}
                            </NavLink>
                          </div>
                        </td>
                        <td className={`${st.tdMiddle} ${st.textAlignCenter}`}>
                          <div
                            className={`${st.groupDescription} ${st.medium}`}
                          >
                            {row.location_name}
                          </div>
                        </td>
                        <td className={`${st.tdMiddle} ${st.textAlignCenter}`}>
                          <div
                            className={`${st.groupDescription} ${st.bottom}`}
                          >
                            <NavLink
                              to={'/groups/group/' + row.group.id}
                              target='_blank'
                            >
                              {row.group.name}
                            </NavLink>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

export default observer(NewStudents)
